import type { FC } from "react";

import { OnOffSwitch, OnOffSwitchSize, PlainTooltip } from "@similarweb/ui-components";

import { useShareOfVoice } from "../others-context/OthersContext";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import { LegendOthersToggleContainer } from "./styles";

interface ITooltipConfig {
    enabled: boolean;
    content: string;
}

interface ILegendOthersToggleProps {
    isDisabled?: boolean;
    tooltip?: ITooltipConfig;
}

export const LegendOthersToggle: FC<ILegendOthersToggleProps> = ({
    isDisabled = false,
    tooltip = { enabled: false, content: "" },
}) => {
    const { includeOtherShareOfVoice, setIncludeOtherShareOfVoice } = useShareOfVoice();
    const translate = useTranslation();

    return (
        <PlainTooltip
            enabled={tooltip.enabled}
            tooltipContent={tooltip.content}
        >
            <LegendOthersToggleContainer>
                <OnOffSwitch
                    size={OnOffSwitchSize.small}
                    isSelected={includeOtherShareOfVoice}
                    isDisabled={isDisabled}
                    onClick={() => setIncludeOtherShareOfVoice((prevState) => !prevState)}
                    onLabel={translate(
                        "seo.keywordsCampaign.keywordsReport.performanceOvertime.graph.legend.includeOthersLabel",
                    )}
                />
            </LegendOthersToggleContainer>
        </PlainTooltip>
    );
};
